import { RULE_TYPES } from '../../RuleBuilder/constants';
import { ExitRuleType } from '../types';

export const EXIT_RULE_TYPES = {
  CUSTOM_EVENT: 'CustomEventExitRule',
  SYSTEM_EVENT: 'SystemEventExitRule',
  USER_PROPERTY: 'UserPropertyExitRule',
  COMBO_RULE: 'ExitRuleCombo',
  CONVERSION_MET: 'ConversionMetExitRule',
} as Record<string, ExitRuleType>;

export const EXIT_RULE_TYPES_TO_RULE_TYPES = {
  [EXIT_RULE_TYPES.CUSTOM_EVENT]: RULE_TYPES.CUSTOM_EVENT,
  [EXIT_RULE_TYPES.SYSTEM_EVENT]: RULE_TYPES.SYSTEM_EVENT,
  [EXIT_RULE_TYPES.USER_PROPERTY]: RULE_TYPES.USER_PROPERTY,
  [EXIT_RULE_TYPES.COMBO_RULE]: RULE_TYPES.COMBO_RULE,
  [EXIT_RULE_TYPES.CONVERSION_MET]: RULE_TYPES.CONVERSION_MET,
};

export const RULE_TYPES_TO_EXIT_RULE_TYPES = {
  [RULE_TYPES.CUSTOM_EVENT]: EXIT_RULE_TYPES.CUSTOM_EVENT,
  [RULE_TYPES.SYSTEM_EVENT]: EXIT_RULE_TYPES.SYSTEM_EVENT,
  [RULE_TYPES.USER_PROPERTY]: EXIT_RULE_TYPES.USER_PROPERTY,
  [RULE_TYPES.COMBO_RULE]: EXIT_RULE_TYPES.COMBO_RULE,
  [RULE_TYPES.CONVERSION_MET]: EXIT_RULE_TYPES.CONVERSION_MET,
};
